import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Header = styled.div`
  text-align: center;
  padding-bottom: ${space['space-1200']};
  margin-bottom: ${space['space-1200']};
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
`;

export const ConfirmationMeta = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  margin: ${space['space-200']} 0 0;
  line-height: ${primitives.typography.lineHeight.relaxed};

  strong {
    color: ${semantic.text.primary};
    font-weight: ${fonts.weight.semiBold};
  }
`;

export const VoucherList = styled.ul`
  list-style: none;
  margin: ${space['space-200']} 0 0;
  padding: 0;
`;

export const VoucherItem = styled.li`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.relaxed};
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['space-1200']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 1fr 1fr;
    gap: 0;
    align-items: stretch;
  }
`;

export const BookingColumn = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-right: ${space['space-1200']};
  }
`;

export const SectionTitle = styled.h2`
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0 0 ${space['space-300']};
  max-width: ${layout.modalWidth};
`;

export const BookingList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ManageBooking = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    border-left: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    padding-left: ${space['space-1200']};
  }
`;

export const ManageBookingDescription = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.relaxed};
  max-width: ${layout.modalWidth};
`;

export const CreateAccountForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  max-width: ${layout.modalWidth};
`;

export const UpsellSection = styled.div`
  margin-top: ${space['space-2000']};
  text-align: center;
`;

export const UpsellGridWrapper = styled.div`
  text-align: left;
  margin-top: ${space['space-800']};
`;
